import React from 'react';

interface ShieldPulseIconProps {
    size?: number;
    className?: string;
}

/**
 * Custom SVG icon: shield outline with a heartbeat/pulse line through the centre.
 * Designed to match the 18 px icon size used in TopBar icon buttons.
 */
const ShieldPulseIcon: React.FC<ShieldPulseIconProps> = ({ size = 18, className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.8}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        aria-hidden="true"
    >
        {/* Shield body */}
        <path d="M12 2L3.5 6.5V11c0 5.25 3.6 10.15 8.5 11.5 4.9-1.35 8.5-6.25 8.5-11.5V6.5L12 2z" />
        {/* Pulse/heartbeat line */}
        <polyline points="7 13 9.5 13 10.5 10 12 16 13.5 11 14.5 13 17 13" />
    </svg>
);

export default ShieldPulseIcon;
